import { render, staticRenderFns } from "./PageEducatorUserMissionAdd.vue?vue&type=template&id=4c6dc65d&scoped=true&"
import script from "./PageEducatorUserMissionAdd.vue?vue&type=script&lang=js&"
export * from "./PageEducatorUserMissionAdd.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorUserMissionAdd.vue?vue&type=style&index=0&id=4c6dc65d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6dc65d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VForm})
